import type { Profile, Workspace } from '../stores/session'

type CrispCommand = [string, string, unknown?]

declare global {
  interface Window {
    $crisp?: CrispCommand[] | { push: (command: CrispCommand) => void }
    CRISP_WEBSITE_ID?: string
  }
}

let loaded = false

/**
 * Crisp live chat (D-08 keeps it; legacy `@dansmaculotte/vue-crisp-chat`, `main.js:33-39`). Loaded only when the build
 * sets `VITE_CRISP_WEBSITE_ID` (the website id lives in the host's `.env`, not in the repository).
 */
export function loadCrisp(websiteId: string | null): void {
  if (!websiteId || loaded || typeof document === 'undefined') return
  loaded = true
  window.$crisp = []
  window.CRISP_WEBSITE_ID = websiteId
  const script = document.createElement('script')
  script.src = 'https://client.crisp.chat/l.js'
  script.async = true
  document.head.appendChild(script)
}

export function crispAvailable(): boolean {
  return loaded
}

function push(command: CrispCommand): void {
  window.$crisp?.push(command)
}

/** Legacy navbar: nickname `"<Label> (U:<Id> / WS:<workspace Id>)"`, e-mail, company = workspace label. */
export function identifyCrispUser(profile: Profile, workspace: Workspace | null): void {
  if (!loaded) return
  const label =
    typeof profile.Label === 'string' ? profile.Label : `${profile.FirstName ?? ''} ${profile.LastName ?? ''}`
  push(['set', 'user:nickname', [`${label} (U:${profile.Id} / WS:${workspace?.Id ?? 0})`]])
  if (profile.Email) push(['set', 'user:email', [profile.Email]])
  if (workspace?.Label) push(['set', 'user:company', [workspace.Label]])
}

/** Help menu "Live chat support". */
export function openCrispChat(): void {
  push(['do', 'chat:open'])
}
